import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=1c75211c"
import script from "./customers.vue?vue&type=script&lang=js"
export * from "./customers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PayCreditModal: require('/home/ubuntu/complete-nuxt-js/components/pay-credit-modal.vue').default,CustomerModal: require('/home/ubuntu/complete-nuxt-js/components/customer-modal.vue').default})
